import { Marked } from 'marked'

/**
 * A Marked instance that strips raw HTML from markdown input,
 * preventing XSS when rendering LLM or user-supplied markdown via innerHTML.
 */
const stripHtml = () => ''
const safeMarked = new Marked({ breaks: true })
safeMarked.use({
  renderer: { html: stripHtml },
  extensions: [{ name: 'htmlInline', renderer: stripHtml }],
})

export { safeMarked }
